import {
  carIOCardCarList,
  carIOCardAddData,
  carIOCardUpdateData,
  carIOCardDeleteData
} from '@/api/api'

const state = {
  carIOCardList: [],
  carIOCardTotal: 0
}

const getters = {
  carIOCardList: state => state.carIOCardList,
  carIOCardTotal: state => state.carIOCardTotal
}

const actions = {
  loadCarIOCardList ({ dispatch }, parm) {
    return carIOCardCarList(parm).then((data) => {
      dispatch('setCarIOCardList', data.list)
      dispatch('setCarIOCardTotal', data.total)
    })
  },
  addCarIOCard ({ commit }, parm) {
    return carIOCardAddData(parm).then((data) => {
    })
  },
  updateCarIOCard ({ commit }, parm) {
    return carIOCardUpdateData(parm)
  },
  delCarIOCard ({ commit }, gasId) {
    return carIOCardDeleteData(gasId)
  },
  setCarIOCardList ({ commit }, data) {
    commit('setCarIOCardList', data)
  },
  setCarIOCardTotal ({ commit }, data) {
    commit('setCarIOCardTotal', data)
  }
}

const mutations = {
  setCarIOCardList (state, data) {
    state.carIOCardList = data
  },
  setCarIOCardTotal (state, data) {
    state.carIOCardTotal = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/base_data/car_io_card.js